import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "gamecenter",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"]),
    ...userVuex.mapState(["userData", "userLocation"])
  },
  data() {
    return {
      gameList: [{
        name: "Bubble Shooter",
        icon: require(`@images/tapcoin/game/bubbleShooter/icon.jpg`),
        target: "/game/bubbleShooter",
        is_new: true,
        game_type: "bubbleShooter",
        user_count: 0,
        is_hot: false
      }, {
        name: "2048 Infinite",
        icon: require(`@images/tapcoin/game/2048/icon.jpg`),
        target: "/game/2048",
        is_new: false,
        game_type: "2048",
        user_count: 0,
        is_hot: true
      }, {
        name: "Tile Connect",
        icon: require(`@images/tapcoin/game/tileConnect/icon.jpg`),
        target: "/game/tileConnect",
        is_new: false,
        game_type: "tileConnect",
        user_count: 0,
        is_hot: true
      }, {
        name: "Zen Blocks",
        icon: require(`@images/tapcoin/game/zenBlocks/icon.jpg`),
        target: "/game/zenBlocks",
        is_new: false,
        game_type: "zenBlocks",
        user_count: 0,
        is_hot: false
      }, {
        name: "AA Game",
        icon: require(`@images/tapcoin/game/aaGame/icon.jpg`),
        target: "/game/aaGame",
        is_new: false,
        game_type: "aaGame",
        user_count: 0,
        is_hot: false
      }, {
        name: "Circle Merge",
        icon: require(`@images/tapcoin/game/circleMerge/icon.jpg`),
        target: "/game/circleMerge",
        is_new: false,
        game_type: "circleMerge",
        user_count: 0,
        is_hot: false
      }, {
        name: "TapUp",
        icon: require(`@images/tapcoin/game/tapUp/icon.jpg`),
        target: "/game/tapUp",
        is_new: false,
        game_type: "tapUp",
        user_count: 0,
        is_hot: false
      }, {
        name: "Fruit Rush",
        icon: require(`@images/tapcoin/game/fruitRush/icon.jpg`),
        target: "/game/fruitRush",
        is_new: false,
        game_type: "fruitRush",
        user_count: 0,
        is_hot: false
      }, {
        name: "Tile by Tile",
        icon: require(`@images/tapcoin/game/sheep/icon.jpg`),
        target: "/game/sheep",
        is_new: false,
        game_type: "sheep",
        user_count: 0,
        is_hot: false
      }, {
        name: "Coming soon",
        icon: require(`@images/tapcoin/comingsoon.jpg`),
        target: "",
        game_type: "comingsoon",
        user_count: 0
      }]
    };
  },
  methods: {
    async getGameTotalInfo() {
      const res = await this.$http.post("/game/data", {});
      console.log("55555555555");
      if (!res) {
        return;
      }
      if (res.code != 0) {
        return;
      }
      if (!res?.data) {
        return;
      }
      const data = res.data;
      this.gameList.map(item => {
        data.map(it => {
          if (item.game_type == it.game_type) {
            item["user_count"] = it.user_count;
            item["is_now"] = it?.is_now;
            item["is_hot"] = it?.is_hot;
          }
        });
      });
      console.log();
      console.log("res1111111", res, this.gameList);
    },
    onSkip(t) {
      if (!t.target) return;
      this.$router.push(t.target);
    }
  },
  mounted() {
    this.getGameTotalInfo();
  }
};